import {get, post, listAll} from '../utils';

const dao = {
  listAllLinks: async params => await listAll(dao.listLinks, params),
  listLinks: async () =>
    await get('/smb-backend/partner/referrallink/list-referral-links.action'),
  deleteLink: async linkId =>
    await get('/smb-backend/partner/referrallink/delete-referral-link.action', {
      referralLinkId: linkId,
    }),
  createLink: async params =>
    await post(
      '/smb-backend/partner/referrallink/create-referral-link.action',
      params
    ),
  queryLink: async linkId =>
    await get('/smb-backend/partner/referrallink/query-referral-link.action', {
      linkId,
    }),
};

export default dao;
